var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"default"},_vm._l((_vm.pageObjectForSlug(this.$route.name)),function(item){return _c('div',[_c('vue-markdown',[_vm._v(" "+_vm._s(item.text)+" ")]),_vm._v(" "),_c('vue-markdown',[_vm._v(" "+_vm._s(item.text2)+" ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09ba1a8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Default.vue
// module id = 101
// module chunks = 1